<div class="fullpage-loader_cotainer" *ngIf="fullpageLoading">
  <mat-spinner></mat-spinner>
</div>
<ng-container *ngIf="isAuthenticated(); else unauthenticated">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #unauthenticated>
  <router-outlet>
    
  </router-outlet>
</ng-template>